import { RootState } from '../../root.model'
import { createSelector, select } from '@ngrx/store'
import { SavedView, WorkspaceRedux } from './workspace.reducer'
import { pipe } from 'rxjs'
import {
  distinctUntilChanged,
  filter,
  map,
  mergeAll,
  takeWhile,
} from 'rxjs/operators'

const workspaceState = (state: RootState) => state.helios.workspace

export const selectActiveWorkspace = createSelector(
  workspaceState,
  (state: WorkspaceRedux) => state.activeWorkspace,
)

export const selectActiveSavedViews = createSelector(
  workspaceState,
  (state: WorkspaceRedux) => state.activeSavedViews,
)

export const selectUpdatedSavedView = createSelector(
  workspaceState,
  (state: WorkspaceRedux) => state.updatedSavedView,
)

export const selectActiveSavedViewForGrid = (gridKey: string) =>
  pipe(
    select(workspaceState),
    map(state => state.activeSavedViews ?? []),
    mergeAll(),
    filter(view => view.gridKey === gridKey),
    distinctUntilChanged(),
  )

export const selectSavedViewExistsForGridKey = (gridKey: string) =>
  pipe(
    select(workspaceState),
    map(state => state.activeSavedViews),
    takeWhile(views => views == null, true),
    filter((views): views is SavedView[] => views != null),
    map(views => views.some(view => view.gridKey === gridKey)),
  )

export const selectUsingLocalStorage = createSelector(
  workspaceState,
  (state: WorkspaceRedux) => state.usingLocalStorage,
)

export const selectWorkspacesLoaded = createSelector(
  workspaceState,
  (state: WorkspaceRedux) => state.workspacesLoaded,
)

export const isPanelOnActiveTab = (panelKey: string) =>
  pipe(
    select(workspaceState),
    map(state =>
      Object.entries(state.activeTabsPerStack).some(
        entry => entry[1] === panelKey,
      ),
    ),
    distinctUntilChanged(),
  )
